import React from 'react';
import { Link } from 'react-router-dom';

const OrderNowButton = () => {
  return (
    <div className='text-center mt-20' style={{ display: 'flex', justifyContent: 'center', paddingLeft: '10px', paddingRight: '10px' }}>
      <Link to='/order-food' style={{ width: '100%', maxWidth: '200px', boxSizing: 'border-box' }}>
        <div className='primary-button' style={{ textAlign: 'center', width: '100%', margin: '0', boxSizing: 'border-box' }}>Order Now</div>
      </Link>
    </div>
  );
};

export default OrderNowButton;
